import React from "react";

const About = () => {
  return (
    <div
      name="about"
      className="w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            About
          </p>
        </div>

        <p className="text-xl mt-20" style={{fontFamily:'Poppins'}}>
        As a college student, I have a talent for Java and web development. 
          I am skilled at designing and building advanced web applications.
          My passion for exploring various web technologies, including HTML, CSS, and JavaScript, 
          has allowed me to stay at the forefront of web development trends and continually improve my abilities.
       
        </p>

        <br />

        <p className="text-xl" style={{fontFamily:'Poppins'}}>
          I am eager to leverage my expertise and drive to contribute to exciting 
          projects and further enhance my proficiency in the field.
        </p>
      </div>
    </div>
  );
};

export default About;
